const { getPublicPath } = require('@experiences/build/rsbuild/publicPath');

// eslint-disable-next-line no-undef
__webpack_public_path__ = getPublicPath('portal');
